import { render } from "./uploadFile.vue?vue&type=template&id=c4af19b6"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"

import "./uploadFile.vue?vue&type=style&index=0&id=c4af19b6&lang=css"

import exportComponent from "C:\\Users\\hkun\\Downloads\\print_shop-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__